export const app_title = 'Easier';
export const payPercentageOptions = [
	{ label: "100%", value: 100 },
	{ label: "50%", value: 50 },
	{ label: "0%", value: 0 },
]

export const ActionType = {
	// 1: "GET",
	2: "post",
	3: "put",
	4: "delete"
};
export const PageType = {
	1: "tower",
	2: "flat",
	3: "opening_balance",
	4: "estimated_expenses",
	5: "settlement",
	6: "user_log",
	7: "login",
	8: "update_password",
	9: "chat",
	10: "complete_profile",
};


export const colorThemes = {
	blue: { primary: "#336a86", hoverPrimary: "#28556c", secondary: "#e8fffe" },
	ocean: { primary: "#0077b6", hoverPrimary: "#005f8d", secondary: "#90e0ef" },
	sunset: { primary: "#ff6f61", hoverPrimary: "#e55b50", secondary: "#ffe0e0" },
	forest: { primary: "#2a9d8f", hoverPrimary: "#21867a", secondary: "#e9f5f0" },
	twilight: { primary: "#6a4c93", hoverPrimary: "#5a3e80", secondary: "#f0e5f5" },
	desert: { primary: "#d6a76a", hoverPrimary: "#b58b52", secondary: "#fef7e1" },
	berry: { primary: "#b83b5e", hoverPrimary: "#a0304b", secondary: "#f4d0d6" },
	metallic: { primary: "#8c8c8c", hoverPrimary: "#757575", secondary: "#e7e7e7" },
	peach: { primary: "#ff9a8b", hoverPrimary: "#e68a79", secondary: "#ffebd1" },
	nightSky: { primary: "#1e1a78", hoverPrimary: "#17135c", secondary: "#d1d1e0" },
};